import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { RiMenu4Line } from "react-icons/ri";
import { IoClose } from "react-icons/io5";
import { FiUsers } from "react-icons/fi";
import { MdAdminPanelSettings } from "react-icons/md";

const menuItems = [
  {
    label: "Admin",
    icon: <MdAdminPanelSettings size={20} />,
    path: "/admin",
  },
  {
    label: "Users",
    icon: <FiUsers size={20} />,
    path: "/users",
  }
];

const SidebarContent = ({ currentPath, navigate }) => (
  <div
    style={{
      background: "#181818",
      height: "100%",
      display: "flex",
      flexDirection: "column",
    }}
  >
    {/* Brand header */}
    <div style={{ padding: "28px 24px 36px" }}>
      <div
        style={{
          color: "#C9A84C",
          fontWeight: 800,
          fontSize: "20px",
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          lineHeight: 1.2,
        }}
      >
        Secure Portal
      </div>
      <div
        style={{
          color: "#888",
          fontSize: "12px",
          letterSpacing: "0.15em",
          marginTop: "6px",
          textTransform: "uppercase",
        }}
      >
        Verified Admin
      </div>
    </div>

    {/* Nav items */}
    <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
      {menuItems.map((item) => {
        const isActive = currentPath === item.path;
        return (
          <li key={item.path}>
            <div
              onClick={() => navigate(item.path)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "18px",
                padding: "14px 24px",
                borderLeft: isActive
                  ? "3px solid #C9A84C"
                  : "3px solid transparent",
                background: isActive ? "#222222" : "transparent",
                cursor: "pointer",
                transition: "background 0.2s",
              }}
              onMouseEnter={(e) => {
                if (!isActive) e.currentTarget.style.background = "#202020";
              }}
              onMouseLeave={(e) => {
                if (!isActive) e.currentTarget.style.background = "transparent";
              }}
            >
              <span
                style={{
                  color: isActive ? "#C9A84C" : "#8a7a55",
                  display: "flex",
                }}
              >
                {item.icon}
              </span>
              <span
                style={{
                  fontSize: "13px",
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                  color: isActive ? "#C9A84C" : "#888888",
                  fontWeight: isActive ? 600 : 400,
                }}
              >
                {item.label}
              </span>
            </div>
          </li>
        );
      })}
    </ul>
  </div>
);

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <React.Fragment>
      {/* Desktop sidebar */}
      <div
        className="lg:block hidden flex-shrink-0 h-screen"
        style={{ width: "240px", background: "#181818" }}
      >
        <SidebarContent currentPath={pathname} navigate={navigate} />
      </div>

      {/* Mobile sidebar */}
      <div className="block lg:hidden">
        <button
          onClick={toggleSidebar}
          style={{
            position: "absolute",
            left: "16px",
            top: "12px",
            color: "#C9A84C",
            background: "none",
            border: "none",
            cursor: "pointer",
            zIndex: 60,
          }}
        >
          {isSidebarOpen ? <IoClose size={28} /> : <RiMenu4Line size={28} />}
        </button>

        <AnimatePresence>
          {isSidebarOpen && (
            <>
              {/* Backdrop */}
              <motion.div
                onClick={toggleSidebar}
                style={{
                  position: "fixed",
                  inset: 0,
                  background: "rgba(0,0,0,0.6)",
                  zIndex: 40,
                }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
              />
              {/* Drawer */}
              <motion.div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "240px",
                  height: "100vh",
                  zIndex: 50,
                }}
                initial={{ x: "-100%" }}
                animate={{ x: 0 }}
                exit={{ x: "-100%" }}
                transition={{ duration: 0.25 }}
              >
                <SidebarContent currentPath={pathname} navigate={navigate} />
              </motion.div>
            </>
          )}
        </AnimatePresence>
      </div>
    </React.Fragment>
  );
};

export default Sidebar;